<template>

  <v-layout class="dialog-modal back" column fill-height justify-start ma-0>
    <scroll-area>
      <template slot="header">
        <v-toolbar dark color="secondary" dense>
          <v-toolbar-title>
            <v-layout justify-start align-center>     
              <svg-icon
                name="radio"
                :color="$getColor(this.$store.state.monitoring.status[getData.$id])"
                width="20"
                style="margin-left: 2px; margin-right: 4px; opacity: .6"
              />
              <span class="body-2 text-uppercase">{{' ' + getData.name + ' ' + getData.template}}</span>
            </v-layout>
          </v-toolbar-title>
          <v-layout fill-height ma-0>
            <v-layout fill-height justify-end align-center>
              <v-btn :data-testid="$options.name + 'v-btn' + 'emit-close'" small icon @click="() => {$emit('close')}" color="secondary">
                <v-icon small>close</v-icon>
              </v-btn>
            </v-layout>            
          </v-layout>  
        </v-toolbar>
      </template>
      <template slot="body">

        <v-layout column fill-height justify-start >

          <v-tabs
            light
            class="pt-1"
            v-model="panel"
            height="38px"
          >

            <v-tabs-slider color="transparent" style="height: 0px; max-width: 0px"></v-tabs-slider>

            <v-tab
              class="font-weight-normal "
              v-for="(place, index) in getPlaces"
              :key="index"

            >
              <template slot="default">
                <div class="tab_wrapper">
                  <div :class="getPlaces[panel] == place ? 'tab__border' : 'custom-tab'">
                    {{ $t(place) }} 
                  </div>
                </div>
              </template>

            </v-tab>

          </v-tabs>

          <!-- <v-layout column fill-height pa-1>             -->
          <v-layout column  v-if="getPlaces[panel] == 'main'" pa-1>
            <!-- {{ getRefs }} -->
            <v-layout column shrink v-if="getRefs.endpoint && getRefs.endpoint.length" >
              
              <!-- <v-card flat> -->
                <v-list three-line header dense>
                  <v-list-tile
                    v-for="(ref, index) in getRefs.endpoint"
                    :key="index + '_list'"
                    :class="'primary--text'"
                    ripple
                    avatar
                    @click=""
                  >

                    <v-list-tile-avatar>
                      <svg-icon
                        slot="activator"
                        name="radio"
                        :color="$getColor($store.state.monitoring.status[ref.$id])"
                        width="20"
                        height="20"
                        style="margin-left: 4px; margin-top: 16px; opacity: .6"
                      />
                    </v-list-tile-avatar>

                    <v-list-tile-content>
                      <v-list-tile-sub-title class="caption font-weight-medium font-condensend" style="white-space: normal">{{ ref.namePath.split('/').slice(2).join('/')}}</v-list-tile-sub-title>
                      <!-- <v-list-tile-title class="caption font-weight-medium font-condensend">{{ ref.namePath.slice(10)}}</v-list-tile-title> -->
                    </v-list-tile-content>
                  </v-list-tile>
                </v-list>

            </v-layout>

            <v-flex shrink v-if="getFields" v-for="(field, index) in getFields" :key="'text' + field.name" pa-0>
              <v-flex v-if="field.show == 'true' && field.value && field.place == 'main'" shrink px-0 pb-1>
                <v-text-field
                  v-if="field.value"
                  :value="$t(field.value)"
                  light
                  outline
                  flat
                  readonly
                  :label="$t(field.name)"
                  :textarea="field.name == 'comment'"
                  class="white"
                  background-color="white"
                  hide-details
                  rows="4"
                >
                </v-text-field>
              </v-flex>
            </v-flex>
          </v-layout>
          
          <v-layout column  v-if="getPlaces[panel] == 'resources'" pa-1>
          
            <v-layout v-if="getData.model == 'ethernet' && getItemTemplate" justify-space-between px-3 pb-3>

              <span class="body-2 text-uppercase">{{$t('resource volume')}}: </span>
              <span class="body-2">{{getItemTemplate.value}} {{getItemTemplate.type}}</span>

            </v-layout>

            <resources-tree
              v-if="model.links && getData.model != 'ethernet'"
              :nodes="model.links"
              @loadchildren="(payload)=> {loadchildren(payload)}"
            />

            <v-layout v-if="getData.model == 'ethernet' && getConsumers.length" justify-space-between px-3 pb-3>
              <span class="body-2 text-uppercase">{{$t('utilization rate')}}: </span>
              <span class="body-2 text-uppercase">{{getLoadIndicator / getItemTemplate.value}} </span>
            </v-layout>

            <v-layout v-if="getData.model == 'ethernet' && getConsumers.length" justify-space-between px-3>
              <span class="body-2 text-uppercase font-weight-black">{{$t('consumers')}}: </span>
            </v-layout>

            <v-layout v-if="getData.model == 'ethernet'" justify-space-between px-3
              v-for="(item, index) in getConsumers"
              :key="index"
            >
              <span class="body-2 text-uppercase">{{consumers[item.id].name}} ( {{$t(consumers[item.id].cls)}} )</span>
              <span class="body-2 text-uppercase">{{item.resource + '(Mb/s)'}}</span>
            </v-layout>


          </v-layout>

          <v-layout column  v-if="getPlaces[panel] == 'paths'" pa-1>
            <scroll-table
              :data="getPaths"
              :options="getOptions"
              :titled="true"
              subscribed
              @select=""
            />           
          </v-layout>

          <v-layout column  v-if="getPlaces[panel] == 'channels'" pa-1>
            <scroll-table
              :data="getChannels"
              :options="getOptions"
              :titled="true"
              subscribed
              @select=""
            />  
          </v-layout>         

        </v-layout>
      </template>
    </scroll-area>
  </v-layout>
</template>

<script lang="ts">
import Vue from 'vue'
import scrollArea from '@/nms/components/partials/scrollarea.vue'
import scrollTable from '@/nms/components/partials/scrolltable.vue'
import resourcesTree from '@/nms/components/equipment/resources-tree.vue'
import svgIcon from '@/nms/components/media/svg/static/svg-icon.vue'

const resource_model = require('@entcor/ebridge/resource-model')

// Типы
interface TableColumn {
  title: string
  value: string
  type: string
  width: string
}

interface TableData {
  columns: TableColumn[]
  rows: any[]
}

interface OptionsColumns {
  [key: string]: { width: string }
}

interface OptionsData {
  columns: OptionsColumns
}

interface ModelData {
  fields: Record<string, any>
  refs: Record<string, any[]>
  brefs: Record<string, any[]>
  obj: Record<string, any>
  image: any | null
  endpoint: any[]
  devices: any[]
  links: any[]
}

interface ConnectionResources {
  resources: any | null
  model: any | null
}

interface ConsumersMap {
  [key: string]: any
}

interface PopupCardData {
  panel: number
  itemTemplate: any | null
  consumers: ConsumersMap
  connectionResources: ConnectionResources
  dataObj: any | null
  meta: any | null
  model: ModelData
  options: OptionsData
  channelsTable: TableData
  template?: any
}

interface PopupCardProps {
  $id?: string
  id?: string
  cls?: string
  template?: string
  name?: string
  [key: string]: any
}

export default Vue.extend({
  name: 'POPUP_CARD',

  components: {
    scrollArea,
    scrollTable,
    svgIcon,
    resourcesTree
  },

  props: {
    data: {
      type: Object as () => PopupCardProps,
      default: () => ({})
    },
  },

  data(): PopupCardData {
    return {
      panel: 0,
      itemTemplate: null,
      consumers: {},
      connectionResources: {
        resources: null,
        model: null
      },
      dataObj: null,
      meta: null,
      model: {
        fields: {},
        refs: {},
        brefs: {},
        obj: {},
        image: null,
        endpoint: [],
        devices: [],
        links: []
      },
      options: {
        columns: {
          text: { width: '40%' },
          timestamp: { width: '40%' },
          actions: { width: '40%' },
          endpoint: { width: '40%' },
          check: { width: '20%' },
        },
      },
      channelsTable: {
        columns: [
          {
            title: 'name',
            value: 'name',
            type: 'text',
            width: '30%'
          },
          {
            title: 'status',
            value: 'status',
            type: 'status',
            width: '10%'
          },
          {
            title: 'type',
            value: 'type',
            type: 'text',
            width: '20%'
          },
          {
            title: 'utilized_resource_type',
            value: 'utilized_resource_type',
            type: 'text',
            width: '20%'
          },
          {
            title: 'resources',
            value: 'resources',
            type: 'array',
            width: '10%'
          },
        ],
        rows: []
      }
    }
  },

  watch: {
    data: {
      handler(newVal: PopupCardProps): void {
        if (newVal) {
          this.setup()
        }
      },
      deep: true
    },
  },

  computed: {
    getData(): PopupCardProps {
      return this.dataObj ? this.dataObj : this.data
    },
    getFields(): Record<string, any> {
      return this.model.fields
    },
    getRefs(): Record<string, any[]> {
      return this.model.refs
    },
    getBrefs(): Record<string, any[]> {
      return this.model.brefs
    },
    getPlaces(): string[] {
      return ['main', 'resources', 'paths', 'channels']
    },
    getChannels(): TableData {
      const t = this.$merge({}, this.channelsTable) as TableData
      t.rows = t.rows.filter(row => row.cls === 'channel')
      return t
    },
    getPaths(): TableData {
      const t = this.$merge({}, this.channelsTable) as TableData
      t.rows = t.rows.filter(row => row.cls === 'path')
      return t
    },
    getOptions(): OptionsData {
      return this.options
    },
    getItemTemplate(): any | null {
      return this.itemTemplate
    },
    getConsumers(): any[] {
      if (this.model.links[0]?.consumers) {
        return this.model.links[0].consumers
      }
      return []
    },
    getLoadIndicator(): number {
      if (this.model.links[0]?.consumers) {
        let indicator = 0
        this.model.links[0].consumers.forEach((item: any) => {
          indicator = indicator + item.resource
        })
        return indicator
      }
      return 0
    },
  },

  created(): void {
    this.setup()
  },

  methods: {
    async setup(): Promise<void> {
      if (!this.getData.$id) return
      this.reset()
      this.statusUnsubscribe('POPUP_CARD')
      console.log('POPUP_CARD SETUP', this.data)
      await this.loadTemplate()
      await this.loadMeta()
      await this.loadLinks()
    },

    async loadMeta(caller?: string): Promise<void> {
      try {
        this.setLoader('loadMeta', true)
        this.meta = await this.$loadMeta(this.getData)
        if (this.meta) {
          this.model = await this.$prepareMeta(this.meta, this.$options.name)
          this.prepareData()
        }
        this.setLoader('loadMeta', false)
      } catch (error) {
        this.setLoader('loadMeta', false)
      }
    },

    async prepareData(): Promise<void> {
      try {
        const query = {
          id: [this.data.$id],
          notNull: true,
          data: {
            namePath: true,
            refs: {
              notNull: true,
              data: { namePath: true }
            },
            brefs: {
              notNull: true,
              data: { namePath: true }
            },
          }
        }
        const obj$ = await this.$bridge.cmdbQuery(query)
        this.statusSubscribe(obj$, 'POPUP_CARD')
        const obj = obj$[0]
        console.log('POPUP_CARD obj', obj)

        const fields = Object.keys(this.model.fields)
        fields.forEach(name => {
          if (obj[name]) {
            this.$set(this.model.fields[name], 'value', obj[name])
          }
        })

        if (this.meta.refs && obj.refs) {
          const refs$ = obj.refs
          this.statusSubscribe(refs$, 'POPUP_CARD')
          refs$.forEach((ref$: any) => {
            this.$set(this.model.fields[ref$.ref], 'value', ref$.name)
            if (!this.model.refs[ref$.ref]) {
              this.$set(this.model.refs, ref$.ref, [])
            }
            if (ref$.ref === 'endpoint') {
              this.model.refs[ref$.ref].push(ref$)
              this.loadEndpointDevice(ref$)
            }
          })
        }

        if (obj.brefs?.length) {
          const brefs$ = obj.brefs
          this.statusSubscribe(brefs$, 'POPUP_CARD')
          brefs$.forEach((bref$: any) => {
            if (!this.model.brefs[bref$.cls]) {
              this.$set(this.model.brefs, bref$.cls, [])
            }
            this.model.brefs[bref$.cls].push(bref$)
            const bref_ = this.$merge({}, bref$)
            if (bref_.ref_extra?.items?.length) {
              bref_.resources = bref_.ref_extra.items
              console.log('POPUP_CARD', 'prepareData', 'resources', bref_.resources)
            }
            this.channelsTable.rows.push(bref_)
          })
        }
        console.log('POPUP_CARD', 'prepareData', 'this.model.fields', this.model.fields)
        console.log('POPUP_CARD', 'prepareData', 'this.model.refs', this.model.refs)
        console.log('POPUP_CARD', 'prepareData', 'this.model', this.model)
      } catch (error) {
        this.setLoader('loadMeta', false)
        console.error('POPUP_CARD prepareData error', error)
      }
    },

    async loadTemplate(): Promise<void> {
      const $_templates = await this.$bridge.getTemplates('connection')
      console.log('POPUP_CARD', 'loadTemplate', '$_templates', $_templates)
      const $_template = $_templates.find((template: any) => {
        return template.id === this.getData.template
      })
      console.log('POPUP_CARD', 'loadTemplate', '$_template', $_template)
      this.template = $_template || null
      this.itemTemplate = $_template?.template?.[0] || null
    },

    async loadLinks(): Promise<void> {
      try {
        this.$set(this.model, 'links', [])
        if (this.getData.cls !== 'connection') return
        
        this.connectionResources.resources = await this.$bridge.customQuery('cmdb', `connection/${this.getData.id}/resources`, {}, 'GET')
        console.log('POPUP_CARD', 'loadLinks', 'resources', this.connectionResources.resources)
        this.connectionResources.model = new resource_model[this.connectionResources.resources.model.model_cls]({})
        this.connectionResources.model.loadBatch(this.connectionResources.resources)

        const model$ = this.connectionResources.model.getTreeLevelByPath('')
        console.log('POPUP_CARD', 'loadLinks', 'model$', model$)
        
        if (model$.items) {
          this.statusSubscribe(model$.items, 'POPUP_CARD')
          for (const item of model$.items) {
            console.log('POPUP_CARD', 'item', item)
            if (item.consumers) {
              for (const consumer of item.consumers) {
                const c_obj$ = await this.$bridge.getObjectById(consumer.id)
                if (c_obj$) {
                  consumer.name = c_obj$.name
                  consumer.template = c_obj$.template
                  this.$set(this.consumers, consumer.id, c_obj$)
                }
              }
            }
            item.items = []
          }
          this.$set(this.model, 'links', model$.items)
          console.log('POPUP_CARD', 'LINKS', this.model.links)
        }
      } catch (error) {
        console.error('POPUP_CARD', 'loadLinks', 'error', error)
      }
    },

    async loadchildren(parent: any): Promise<void> {
      try {
        const model$ = this.connectionResources.model.getTreeLevelByPath(parent.path)
        console.log('POPUP_CARD', 'loadchildren', 'model$', model$)
        
        if (model$.items) {
          model$.items.forEach((item: any) => {
            if (item.type === 'ts') return
            item.items = []
          })
          
          const cycle = (arr: any[]): void => {
            arr.forEach((link, i) => {
              if (link.path === parent.path) {
                this.$set(arr[i], 'items', model$.items)
                return
              }
              if (link.items) {
                cycle(link.items)
              }
            })
          }
          cycle(this.model.links)
        }
      } catch (error) {
        console.error('POPUP_CARD', 'loadchildren', 'error', error)
      }
    },

    async loadEndpointDevice(child$: any): Promise<void> {
      try {
        console.log('POPUP_CARD', 'loadEndpointDevice', 'child$', child$)
        const parent$ = await child$.getParents({ cls: 'device' })
        if (parent$?.[0]) {
          parent$[0].children = await parent$[0].getLinks()
          this.model.devices.push(parent$[0])
        }
      } catch (error) {
        console.error('POPUP_CARD', 'loadEndpointDevice', 'error', error)
      }
    },

    async statusSubscribe(arr: any[], group: string): Promise<void> {
      this.$store.dispatch('measuresSubscribeInit', {
        name: 'addStatus',
        group: group,
        listener: 'status'
      })

      if (arr.length) {
        this.getMirror(arr)
        await this.$bridge.subscribe(arr.map(obj => obj.$id))
      }
    },

    subscribeHandler(e: { $id?: string; [key: string]: any }): void {
      if (e.$id) {
        this.$store.dispatch('addStatus', e)
      }
    },

    statusUnsubscribe(group: string): void {
      this.$store.dispatch('measuresSubscribeClose', {
        handler: this.subscribeHandler,
        group: group,
        listener: 'status'
      })
    },

    getMirror(arr: any[]): void {
      for (const item of arr) {
        if (item.$id) {
          this.$store.dispatch('addStatusKey', item)
        }
        if (item.children?.length) {
          this.getMirror(item.children)
        }
      }
    },

    setLoader(name: string, status: boolean): void {
      this.$store.dispatch('setLoader', {
        key: name,
        value: status
      })
    },

    reset(): void {
      this.panel = 0
      this.dataObj = null
      this.meta = null
      this.itemTemplate = null
      this.consumers = {}
      this.connectionResources = {
        resources: null,
        model: null
      }
      this.model = {
        fields: {},
        refs: {},
        brefs: {},
        obj: {},
        image: null,
        endpoint: [],
        devices: [],
        links: []
      }
      this.options = {
        columns: {
          text: { width: '40%' },
          timestamp: { width: '40%' },
          actions: { width: '40%' },
          endpoint: { width: '40%' },
          check: { width: '20%' },
        },
      }
      this.channelsTable = {
        columns: [
          {
            title: 'name',
            value: 'name',
            type: 'text',
            width: '30%'
          },
          {
            title: 'status',
            value: 'status',
            type: 'status',
            width: '10%'
          },
          {
            title: 'type',
            value: 'type',
            type: 'text',
            width: '20%'
          },
          {
            title: 'utilized_resource_type',
            value: 'utilized_resource_type',
            type: 'text',
            width: '20%'
          },
          {
            title: 'resources',
            value: 'resources',
            type: 'array',
            width: '10%'
          },
        ],
        rows: []
      }
    },
  },
})
</script>

<style lang="css" scoped>

.dialog-modal {
  /* background-color: #ffffff */
  /* min-height: 500px;
  max-height: 500px; */
  min-height: 280px;
  height: 470px;
}

</style>